import PropTypes from 'prop-types'

import BoardModelCard from './BoardModelCard'

import s from './ModelList.module.css'

function ModelList({
  models = [],
  group = '',
  boardSlug = '',
  showFollowers = false,
}) {
  return (
    <>
      <div className={s.container}>
        {models.length > 0 &&
          models
            .filter(({ image }) => image?.defaultColor !== 'false')
            .map((model) => (
              <BoardModelCard
                key={model.id}
                model={model}
                group={group}
                href={`${group}/${boardSlug}/${model.slug}`}
                showFollowers={showFollowers}
              />
            ))}
      </div>
      {models.length < 1 && (
        <div className={s.noItems}>
          <p>
            We do not currently have any models matching your requested criteria
          </p>
        </div>
      )}
    </>
  )
}

ModelList.propTypes = {
  models: PropTypes.array,
  boardSlug: PropTypes.string,
  group: PropTypes.string,
  showFollowers: PropTypes.bool,
}

export default ModelList
